import React, { useState, useEffect } from 'react'
import {Link , useNavigate } from 'react-router-dom'
import { Lock } from 'lucide-react';
// import ComboboxSortBy from '../ComboboxSortBy/ComboboxSortBy'
// import ComboboxSearch from '../ComboboxSearch/ComboboxSearch'
import { SERVERURL } from "../../ServerUrl";
import axios from "axios"

import './HomeProjects.css'

const HEADING = "Projects & Ventures";
const SUBCOPY =
  "Search & get access to our selected list of early-stage Projects in Crypto & Web3";

const CATEGORIES = [
  'All',
  'AI',
  'DeFi',
  'Metaverse',
  'NFTs',
  'Infrastructure',
  'Gaming',
];

const Projects = () => {
  const [token, setToken]=useState(localStorage.getItem('token'));

  const navigate = useNavigate()
  
  const sortby=[
    'Active',
    'Upcoming',
    'Ended',
  ];
  const chainIs=[
    'Solana',
    'Ethereum',
    'Polygon',
  ];
  const stageIs=[
    'Seed',
    'Private Sale',
  ];

  const empty=[];

  const [AuctionData,setAuctionData] = useState([]);



  const [searchedData, setSearchedData] = useState(AuctionData);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedCategorychain, setSelectedCategorychain] = useState(null);
  const [selectedCategorystage, setSelectedCategorystage] = useState(null);

  const [selectedButton, setSelectedButton] = useState(null);
  const handleClick = (event) => {
    
    
    if(selectedCategory===null)
    {const buttonValue = event.target.value;
      
    if(selectedButton===buttonValue){
      setSelectedButton();
      const filteredData = AuctionData;
      setSearchedData(filteredData);  
    }
    else{
      if(buttonValue==='All')
      {
        setSelectedButton(buttonValue);
        const filteredData = AuctionData;
        setSearchedData(filteredData);
              }
        else
        {
          setSelectedButton(buttonValue);
          const filteredData = AuctionData.filter((item) => item.category === buttonValue);
          setSearchedData(filteredData);
        }   
    }
      
    
      
    }
    else
    {
      const buttonValue = event.target.value;
      if(selectedButton!=buttonValue){
        setSelectedButton(buttonValue);
        const filteredData = AuctionData.filter((item) => item.category === buttonValue && item.sortbyy === selectedCategory);
        setSearchedData(filteredData);  
      }
      else{
        setSelectedButton(null);
        const filteredData = AuctionData.filter((item) => item.sortbyy === selectedCategory);
        setSearchedData(filteredData);  
      }

      
    }
    };
    
  
    const handleOptionSelected = (selectedCategory) => {
      // Filter the data based on the selected category
      console.log("selected is "+selectedCategory);
setSelectedCategory(selectedCategory);
      if(selectedButton===null)
      {
        const filteredData = AuctionData.filter((item) => item.sortbyy === selectedCategory);
        setSearchedData(filteredData);
  
      }
      else
      {
        const filteredData = AuctionData.filter((item) => item.sortbyy === selectedCategory && item.category === selectedButton);
        setSearchedData(filteredData);
      }
    };


    const handleOptionSelectedchain = (selectedCategory) => {
      // Filter the data based on the selected category
      console.log("selected is "+selectedCategory);
setSelectedCategorychain(selectedCategory);
      if(selectedButton===null)
      {
        const filteredData = AuctionData.filter((item) => item.chain === selectedCategory);
        setSearchedData(filteredData);
  
      }
      else
      {
        const filteredData = AuctionData.filter((item) => item.chain === selectedCategory && item.category === selectedButton);
        setSearchedData(filteredData);
      }
    };

    
    const handleOptionSelectedstage = (selectedCategory) => {
      // Filter the data based on the selected category
      console.log("selected is "+selectedCategory);
setSelectedCategorystage(selectedCategory);
      if(selectedButton===null)
      {
        const filteredData = AuctionData.filter((item) => item.stage === selectedCategory);
        setSearchedData(filteredData);
  
      }
      else
      {
        const filteredData = AuctionData.filter((item) => item.stage === selectedCategory && item.category === selectedButton);
        setSearchedData(filteredData);
      }
    };



  
    const handleSearch = (searchTerm) => {
      // Compare the searchTerm with auctionData and filter the matched items
      const filteredData = AuctionData.filter((item) =>
        item.title.toLowerCase().includes(searchTerm.toLowerCase())
      );
  
      // Save the matched data in the state
      setSearchedData(filteredData);
    };
  

    useEffect(() => {
      console.log("at least a tw gya");
      // Fetch data from your server using axios or any other library
      axios.get(`${SERVERURL}/api/v1/getProjects`)
        .then((response) => {
          // Assuming your API response contains an array of projects
          let projectsData = response.data;
          let loggedin= localStorage.getItem("loggedin");
          if(loggedin)
          {
            const limitedProjectsData = projectsData.slice(0, 6);

            setAuctionData(limitedProjectsData);
            setSearchedData(limitedProjectsData);          
          }
          else
          {
            let filteredData=projectsData.filter((item) => item.privatee === "False" || item.privatee === "false" ||  item.privatee === null || item.privatee === false || item.privatee === undefined);
            const limitedProjectsData = filteredData.slice(0, 6);

            setAuctionData(limitedProjectsData);
            setSearchedData(limitedProjectsData);
          }

          console.log("at least a tw gya",projectsData,AuctionData);
  
  //        setSearchedData(projectsData);
        })
        .catch((error) => {
          console.error('Error fetching data:', error);
        });
    }, []);
  return (
    <>
           {/* Start */}
<div id='projects' className='revise3' style={{backgroundColor:"#F3F3F3"}}>

      {/* Heading block mirrors the Blog & News section. */}
        <div className="max-w-6xl mx-auto px-4 md:px-10 pt-12 md:pt-16">
          <div className="text-center">
            <h2 className="font-headline font-bold tracking-tight text-[#111113] text-[clamp(1.75rem,3.4vw,2.5rem)] leading-[1.12] m-0">
              {HEADING}
            </h2>
            <p className="font-headline text-[#4a4753] text-base md:text-lg leading-relaxed max-w-4xl mx-auto mt-4 mb-0">
              {SUBCOPY}
            </p>
          </div>

          {/* inline-flex, not flex: HomeProjects.css defines a global `.flex`
              with space-between that stretches the row edge to edge. */}
          <div className="text-center mt-8">
            <div className="inline-flex flex-wrap justify-center gap-1.5">
            {CATEGORIES.map((category) => {
              const active =
                category === 'All'
                  ? !selectedButton || selectedButton === 'All'
                  : selectedButton === category;

              return (
                <button
                  key={category}
                  value={category}
                  onClick={handleClick}
                  className={`rounded-full border !grow-0 !shrink-0 !basis-auto !w-auto !px-5 !py-2 font-headline font-semibold text-sm transition-colors duration-300 ${
                    active
                      ? 'border-accent bg-accent text-accent-ink'
                      : 'border-black/15 bg-transparent text-[#4a4753] hover:border-accent-on-light hover:text-accent-on-light'
                  }`}
                >
                  {category}
                </button>
              );
            })}
            </div>
          </div>
        </div>


          {!token && (
            <div className="max-w-5xl mx-auto px-4 mt-6">
              <div className="flex !flex-nowrap !justify-center items-center gap-3 rounded-full border border-black/10 bg-white px-5 py-3.5">
                <Lock className="w-4 h-4 shrink-0 text-accent-on-light" />
                <p className="font-body text-sm md:text-[15px] text-[#4a4753] text-center m-0">
                  To see our latest &amp; featured projects available for
                  investment, please{" "}
                  <Link
                    to="/user/login"
                    className="text-accent-on-light underline underline-offset-4 hover:opacity-70 transition-opacity"
                  >
                    Log in
                  </Link>{" "}
                  to your account
                </p>
              </div>
            </div>
          )}
</div>
  
          <section className=" new12345" style={{backgroundColor:"#F3F3F3"}}>
        
      

        {/* End Home */}
  
  
          <div className="container container2222">
            <div className="row row-cols-xl-4 row-cols-lg-3 row-cols-sm-2 row-cols-1 g-4">
              {(!searchedData || searchedData.length === 0) ? (
  <div className="no-data-message">
  </div>
) : (searchedData?.map((data, index) => {
                return (
                  <div className="col" key={index}>
                    <div className="card nft-items nft-primary nft-auction upperrounded shadow1 overflow-hidden biggerwidth hoveris h600px" onClick={e => {
                            e.preventDefault()
                            navigate(`user/projectDetail/${data?.title}`)
                          }}>
                      
                      <div className=" rounded-md  position-relative moreheightis overflow-hidden ">
                        <div>
                          <img src={SERVERURL+'/uploads/'+data.image} className="img-fluid objectfitt moreheightis hundredwidth" alt="" />
                        </div>
                        {data?.special && (
                          <div className="special">
                             <i className="fa-solid fa-star staroffeatured"></i> FEATURED
                            </div>
                        )
  
                        }
  
                        <div className="position-absolute topdowner trans leftttt">
  
                         <img className="widthheight borderisss" src={SERVERURL+'/uploads/'+data.logo}  alt="" />
                         </div>
                        
                        
                      </div>
  
                      <div className="card-body content position-absolute moretopandbackcolor moreepaddingtop trans ppp" style={{ backgroundColor: data.funded ? '#fafafa' : '#fff' }}>

  
                      <h3 className="!font-headline !font-semibold !tracking-tight !text-[#111113] text-xl sm:text-2xl leading-7 sm:truncate m-0">
      {data?.title}
      </h3>

                      {/* <div    className="title text-dark h6"
                        >
                          {data?.description}
                        </div> */}
  
                        <div className="d-block align-items-center justify-content-between mt-3">
                          <div className="padtop h100px">
                            <p className="mb-0 d-block fw-semibold12 carddescription !font-headline !text-[#4a4753]">
                              {data?.description}
                            </p>
                          </div>
                          <div className='bottomcard'>
                          <div className="padtop lcc">
                            <p className="mb-0 d-block fw-semibold12 cardlocation !font-headline !text-[#4a4753]">
                              {data?.location}
                            </p>
                          </div>
                          
                          <div className="keywords">
          <div className="keyword !font-headline" >
        {data?.sortbyy}
      </div>
      <div className="keyword !font-headline" >
        {data?.category}
      </div>

  </div>

  <div className="lastline !font-headline">
  CryptoHub Funding Portal · Reg CF
      </div>
      </div>
                        </div>
                      </div>
                      <div className="belower"> 
                      <div className={`belowercontent !font-headline !text-[#4a4753] ${data.funded ? 'funded' : ''}`}> 
                      <span className="prominent !font-headline !font-semibold !text-[#111113]" style={{marginRight:'35px'}}><strong>Chain: </strong></span>           <div className='toggle1'>
  {data.chain}
        </div>
                      </div>
                      <div className={`belowercontent !font-headline !text-[#4a4753] ${data.funded ? 'funded' : ''}`}> 
                        <span className="prominent !font-headline !font-semibold !text-[#111113]" style={{marginRight:'7px'}}><strong>Valuation:</strong></span>{data.valuationCap === 0 ? 'N/A' : `$${data.valuationCap}`}
                      </div>  
                      <div className={`belowercontent !font-headline !text-[#4a4753] ${data.funded ? 'funded' : ''}`} > 
   <span className="prominent !font-headline !font-semibold !text-[#111113]" style={{marginRight:'35px'}}><strong>Stage:   </strong></span> <div className='toggle2'>{data.stage}      
        </div>
                      </div>
                      <div className={`belowercontent !font-headline !text-[#4a4753] ${data.funded ? 'funded' : ''}`}> 
                        <span className="prominent !font-headline !font-semibold !text-[#111113]" style={{marginRight:'50px'}}><strong>TGE:</strong></span> {data.tge}
                      </div>  

                      </div>
                    </div>
                  </div>
                )
              })
            )}

              {/*end col*/}
            </div>
            {/*end row*/}
  
            
            {/*end row*/}
          </div>

          {/*end container*/}
        </section>
        <div style={{backgroundColor:"#F3F3F3"}} className="pt-3 pb-6 md:pb-8">
          <div className="flex !flex-nowrap !justify-center">
            <Link
              to="/user/projects"
              className="rounded-full border border-black/15 px-7 py-3 font-headline font-semibold text-sm text-[#111113] no-underline hover:border-accent-on-light hover:text-accent-on-light transition-colors duration-300"
            >
              View all
            </Link>
          </div>
        </div>
  
      {/*end section*/}
      {/* End */}

      {/* CTA Start */}
      
      {/*end section*/}
      {/* CTA End */}
      
    </>
  )
}

export default Projects
